:host {
  --sizing-max-width-default: 352px;

  display: inline-block;

  // Trigger wrapper for slotted content
  .pds-popover__trigger-wrapper {
    display: inline-block;
  }

  // Content slot wrapper is hidden (content is rendered in portal)
  .pds-popover__content-slot-wrapper {
    display: none;
  }
}
